import './components.css';

interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <label className={`iris-toggle ${disabled ? 'disabled' : ''}`}>
      <span className="iris-toggle-track" data-on={checked}>
        <span className="iris-toggle-thumb" />
      </span>
      {label && <span className="iris-toggle-label">{label}</span>}
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
    </label>
  );
}
